import * as React from "react"
import { SaDefaultHeader2 } from "./saDefaultHeader2"
// @ts-ignore
import { saDefaultSlideSection } from './saDefaultHeader2.module.scss'
import { saInterfaceDefaultSection } from "../saTypes"
// @ts-ignore
//import sabg from '../../../images/background@3x.jpg'


export const SaDefaultHeader2Container: React.FC<saInterfaceDefaultSection> = (props) => {




    return (
      <section id={'saDefaultSlideSection'}
               className={saDefaultSlideSection  + ' ' + props.className}
      >
        <SaDefaultHeader2 {...props}/>
      </section>
    )


}
